import { render } from "./HelloVue.vue?vue&type=template&id=39b5cdf2"
import script from "./HelloVue.vue?vue&type=script&lang=js"
export * from "./HelloVue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cahmpas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__